var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<p class=\"form-text js-form-field-description-content js-form-field-hint-description\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("data-content",c,p,0)));t.b("\n" + i);t.b("</p>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<p class=\"form-text js-form-field-description-content js-form-field-hint-description\">\n    {{{ data-content }}}\n</p>\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./registration/static_source/templates/registration/simple/game/fields/description.html
// module id = 815
// module chunks = 7